import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Input, Button, Card, Typography, message, Space } from 'antd';
import Profile from '../components/Account/Profile';
import { notify } from '../components/Customs/NotifyProvider';
import { navigate } from '../components/Customs/navigation';
import { useLocation } from 'react-router-dom';

const { Title } = Typography;

const SignUpPage = ({handleCloseLogin}) => {
  const [identifier, setIdentifier] = useState('');
  const [otp, setOtp] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [verified, setVerified] = useState(false);
  const [loading, setLoading] = useState(false);
  const [userKey, setUserKey] = useState('');
  const location = useLocation();

  const [redirectTo, setRedirectTo] = useState([]);
  const [redirectData, setRedirectData] = useState([]);

  useEffect(() => {
    const userKey = localStorage.getItem('hc-user-key');
    setUserKey(userKey);

    console.log(userKey);

    if (userKey) {
      setVerified(true);
    } else {
      setVerified(false);
    }
  }, []);

  useEffect(() => {
    if (location.state) {
      setRedirectTo(location.state.redirectTo || null);
      setRedirectData(location.state.data || null);

      console.log("➡️ Redirect To:", location.state.redirectTo);
      console.log("📦 Redirect Data:", location.state.data);
    }
  }, [location.state]);


  // Mock Send OTP API

  const sendOtp = async () => {
    if (!identifier) {
      message.error('Please enter email');
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(
        'https://api.hemacabs.com/api/v1/addon_services/otp',
        {
          email: identifier,
        }
      );

      if (response.data?.status) {
        setOtpSent(true);
        notify.success('OTP sent successfully');
      } else {
        notify.error(response.data?.message || 'Failed to send OTP');
      }
    } catch (error) {
      console.error('Send OTP Error:', error);

      if (error.response) {
        notify.error(error.response.data?.message || 'Server error');
      } else {
        notify.error('Network error. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  // Mock Verify OTP API

  const verifyOtp = async () => {

    if (!otp) {
      message.error('Please enter OTP');
      return;
    }

    const payload = {
      email: identifier,
      otp: otp
    };

    console.log('Verify OTP payload:', payload);

    try {
      setLoading(true);

      const response = await axios.post(
        'https://api.hemacabs.com/api/v1/addon_services/otp/verify',
        payload,
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );

      const { status, message: msg } = response.data;

      if (status) {
        notify.success(msg || 'OTP verified');
        setVerified(true);


        localStorage.setItem('hc-user-key', identifier);
        handleCloseLogin();

        // if (redirectTo && redirectData) {

        //   navigate("/dashboard", {
        //     state: {
        //       // redirectTo: "/car-booking",
        //       data: redirectData
        //     }
        //   });
        // }

      } else {
        notify.error(msg || 'Invalid OTP');
      }

    } catch (error) {
      console.error('Verify OTP API error:', error);

      notify.error(
        error?.response?.data?.message || 'Unable to verify OTP'
      );
    } finally {
      setLoading(false);
    }
  };

  const testReload = async () => {
    //  window.parent.postMessage(
    //     { type: 'RELOAD_PARENT' },  // Custom message type
    //     '*'  // Target origin: '*' allows any (restrict to 'http://127.0.0.1:8000' in production for security)
    //   );
    // window.top.location.reload();
    if (redirectTo && redirectData) {

      navigate("/dashboard", {
        state: {
          redirectTo: "/car-booking",
          data: redirectData
        }
      });
    }

  }


  // After successful OTP verification
  if (verified) {
    return <Profile userKey={userKey} />;
  }

  return (
    <div style={{ display: 'flex', justifyContent: 'center', marginTop: 80 }}>
      <Card style={{ width: 400 }} size='large'>
        <Title level={4} style={{ textAlign: 'center' }}>
          Sign Up / Sign In
        </Title>

        {!otpSent && (
          <>
            <Input
              size='large'
              placeholder="Email"
              value={identifier}
              onChange={(e) => setIdentifier(e.target.value)}
              style={{ marginBottom: 16 }}
            />

            <Button
              size='large'
              type="primary"
              block
              loading={loading}
              onClick={sendOtp}
            // onClick={testReload}
            >
              Send OTP
            </Button>
          </>
        )}

        {otpSent && (
          <>
            <Input
              placeholder="Enter OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              style={{ marginBottom: 16 }}
            />

            <Space  >
              <Button
                type="primary"
                block
                loading={loading}
                onClick={verifyOtp}
              >
                Verify OTP
              </Button>

              <Button
                type="primary"
                ghost
                block
                loading={loading}
                onClick={() => {
                  setOtpSent(true)
                  setOtpSent(false)
                }}
              >
                Resend OTP
              </Button>
            </Space>
          </>
        )}
      </Card>
    </div>
  );
};

export default SignUpPage;
